import { PayloadAction } from '../../../../../store.model';
import { sortSummary } from '../function/sort-summary.function';
import { ActionType } from '../transcript-summary.action';
import { TranscriptSummaryState } from '../transcript-summary.state';

import { SortSummary } from './sort-summary.action';

export function sortSummaryReducer(
    state: TranscriptSummaryState,
    action: PayloadAction<ActionType, SortSummary>,
): TranscriptSummaryState {
    try {
        const nextFiltered = sortSummary(
            action.payload.orderBy,
            state.transcriptCategories,
        );
        return {
            ...state,
            filteredTranscriptCategories: nextFiltered,
            orderBy: action.payload.orderBy,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
